<template>
  <div :id="id" class="msg" :class="[{expanded}, classes]">
    <div class="header" :class="{locked: isLocked}" @click="expanded = !isLocked && !expanded">
      <div class="time" @click.stop="$emit('selectMessage', message)" :title="message.time" v-if="message.timeTitle">
        {{message.timeTitle}}
      </div>
      <div class="title">
        {{message.message}}
        <span class="dots" v-show="isExpandable">...</span>
      </div>
      <div class="host" v-if="host">
        <Logo :entity="host" inline />{{host.name}}
      </div>
    </div>
    <div class="content">
      <!-- <pre>{{message}}</pre> -->
      <sui-message class="inverted error" size="small" v-if="message.stderr" style="">
        {{message.stderr}}
      </sui-message>
      <sui-message class="inverted info" size="small" v-if="message.info">
        {{message.info}}
      </sui-message>
      <sui-message class="inverted stdout" :class="{expanded: expandedStdout}" size="small" v-if="hasStdout" @click="expandedStdout = true">
        <span class="stdout-button" v-show="!expandedStdout">show stdout...</span>
        <span v-show="expandedStdout">{{message.stdout}}</span>
      </sui-message>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'LogMessage',
    props: {
      message: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        expanded: this.message.isError && (this.message.stdout || this.message.stderr || this.message.info),
        expandedStdout: !this.message.stderr && !this.message.info,
      }
    },
    computed: {
      ...mapGetters(['hostsByIP']),
      id() {
        return `msg-${this.message.id}`
      },
      title() {
        return new Date(this.message.timestamp)
      },
      host() {
        return this.hostsByIP[this.message.host]
      },
      classes() {
        return {
          extended: this.message.stdout || this.message.stderr || this.message.info,
          info: this.message.info,
          warning: this.message.stderr || this.message.level === 3,
          error: this.message.isError,
          highlighted: this.message.highlighted,
        }
      },
      isLocked() {
        return !this.message.stdout && !this.message.stderr && !this.message.info
      },
      isExpandable() {
        return this.message.stdout || this.message.stderr || this.message.info
      },
      hasStdout() {
        return this.message.stdout // && !this.message.stderr && !this.message.info
      }
    },
  }
</script>

<style scoped>
  .msg { border-bottom: 1px solid rgba(0, 0, 0, .05); font-family: monospace; white-space: pre-line; transition: background-color .5s; }
  .msg.info { background-color: #def; }
  .msg.extended { background-color: #fafaff; }
  .msg.extended .header { cursor: pointer; }
  .msg.info { background-color: #def; }
  .msg.info .title { color: #009; }
  .msg.warning { background-color: #fed; }
  .msg.warning .title { color: #d72; }
  .msg.warning .error { color: #fd0; }
  .msg.error { background-color: #fee; }
  .msg.error .title { color: #c33; }
  .msg.error .error { color: #f00; }
  .msg.highlighted { background: #ffc; transition: background-color 0s; }
  .msg .info { color: #2185D0; }
  .msg.expanded .content { display: block; }
  .header { display: flex; align-items: justify; color: #333; }
  .header > div { padding: .4em .5em; }
  .time { background-color: rgba(150, 150, 150, .1); opacity: .4; cursor: pointer; }
  .time:hover { opacity: .8; }
  .title { flex: 1; word-break: break-word; }
  .host { opacity: .5; white-space: nowrap; }
  .content { padding: 0 .5em 1em; display: none; word-break: break-word; }
  .stdout-button { color: #ccc; }
  .stdout { cursor: pointer; }
  .stdout:hover .stdout-button { color: #9cf; }
  .stdout.expanded { cursor: auto; }
</style>
